<template>
  <el-dialog title="添加新成员" :visible.sync="visible" width="60%" :before-close="handleClose">
    <div class="add-member-dialog">
      <div class="addCount">
        <div>
          <div class="add-title">添加账号</div>

          <div class="add-input">
            <el-input v-model.trim="addDialog.account" class="addInput"></el-input>
            <el-button class="add-btn" type="primary" @click="addCount">添加</el-button>
          </div>
        </div>
      </div>
      <div class="account-list" v-if="addDialog.accountData.length">
        <el-table class="common-el-table-styles" :data="addDialog.accountData" border style="width: 100%">
          <el-table-column prop="userName" label="账号"> </el-table-column>
          <el-table-column label="成员显示名">
            <template slot-scope="scope">
              <div class="edit">
                <el-input v-model="scope.row.name" placeholder="请输入成员名" @change="getName(scope.row)" size="small"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="功能角色">
            <template slot-scope="scope">
              <div class="edit">
                <el-select
                  v-model="scope.row.roleName"
                  filterable
                  multiple
                  placeholder="请选择"
                  size="small"
                  collapse-tags
                  @change="getRoleName(scope.row.$index, scope.row)"
                >
                  <el-option v-for="item in addDialog.rolesOptions" :key="item.roleId" :label="item.roleName" :value="item.roleId">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数据权限">
            <template slot-scope="scope">
              <div class="edit">
                <el-select
                  v-model="scope.row.dataPermissionVal"
                  filterable
                  multiple
                  placeholder="请选择"
                  collapse-tags
                  size="small"
                  @change="getDataRoles(scope.row.$index, scope.row)"
                  @visible-change="visibleChange"
                >
                  <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="聚合应用" name="first" :disabled="!comprehensiveArr.length">
                      <el-option v-for="item in comprehensiveArr" :key="item.roleId" :label="item.roleName" :value="item.roleId">
                      </el-option>
                    </el-tab-pane>
                    <el-tab-pane label="追踪应用" name="second" :disabled="!polymerization.length">
                      <el-option v-for="item in polymerization" :key="item.roleId" :label="item.roleName" :value="item.roleId"> </el-option>
                    </el-tab-pane>
                  </el-tabs>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="密码">
            <template slot-scope="{ row }">
              <el-input v-model="row.password" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="dele(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="addNewMember">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { queryAllRole, queryAllUsers, addUserApi } from '@/api/sysmana.model'
export default {
  name: 'addUser',
  props: ['openCreate'],
  data() {
    return {
      activeName: 'first',
      addDialog: {
        account: '',
        accountData: [],
        nameOptions: [],
        rolesOptions: []
      },
      comprehensiveArr: [],
      polymerization: [],
      permissionData: [],
      timeout: null,
      btnLoading: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.openCreate
      },
      set(val) {
        this.$emit('update:openCreate', val)
      }
    }
  },
  created() {
    this.getAllUsersName()
    this.getRoles()
  },
  methods: {
    getRoles() {
      queryAllRole({
        deptId: '',
        roleType: 2
      }).then((data) => {
        this.permissionData = data
        data &&
          data.forEach((item) => {
            if (item.authorityType === 3) {
              this.comprehensiveArr.push(item)
            }
            if (item.authorityType === 1) {
              this.polymerization.push(item)
            }
          })
      })
    },
    addCount() {
      // 添加账号
      this.addDialog.accountData = []
      let countArr = []
      const account = this.addDialog.account
      if (account.includes(',')) {
        countArr = account.split(',')
      } else if (account.includes('，')) {
        countArr = account.split('，')
      } else {
        countArr = new Array(account)
      }
      if (countArr.length < 2) {
        for (let i = 0; i < countArr.length; i++) {
          if (!countArr[i]) {
            return this.$message.warning('请输入账号')
          }
        }
      } else if (countArr[countArr.length - 1] === '') {
        countArr.pop()
      }
      countArr.forEach((item) => {
        this.addDialog.accountData.push({
          userName: item,
          roleName: '',
          password: '',
          submitName: '',
          submitRoles: [],
          submitDataRoles: []
        })
      })
      this.getAllRole()
    },
    getAllUsersName() {
      const condition = {
        deptId: '',
        status: 1
      }
      queryAllUsers(condition).then((data) => {
        if (data) {
          // this.addDialog.nameOptions = data
          data.forEach((item) => {
            this.addDialog.nameOptions.push({
              ...item,
              value: item.name
            })
          })
        }
      })
    },
    getAllRole() {
      queryAllRole({
        deptId: '',
        roleType: 1 // 1功能角色 2 数据角色
      }).then((data) => {
        if (data) {
          this.addDialog.rolesOptions = data
        }
      })
    },
    dele(index) {
      this.addDialog.accountData.splice(index, 1)
    },
    getName(row) {
      row.submitName = row.name
      // this.addDialog.nameOptions.forEach(item => {
      //   if (row.name === item.userId) {
      //     row.submitName = item.name
      //   }
      // })
    },
    getRoleName(index, row) {
      row.submitRoles = []
      for (const k of row.roleName) {
        this.addDialog.rolesOptions.forEach((item) => {
          if (k === item.roleId) {
            row.submitRoles.push({
              roleId: item.roleId,
              roleName: item.roleName
            })
          }
        })
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.$emit('openCreateFn', false)
        })
        .catch((_) => {})
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    visibleChange(isShow) {
      if (isShow) {
        const dom = document.querySelector('.el-tabs__active-bar')
        dom.style.transform = 'translateX(0px)'
        this.activeName = 'first'
      }
    },
    getDataRoles(index, row) {
      row.submitDataRoles = []
      console.log(row)
      row.dataPermissionVal.forEach((item) => {
        this.permissionData.forEach((ite) => {
          if (item === ite.roleId) {
            row.submitDataRoles.push({
              roleId: ite.roleId,
              roleName: ite.roleName
            })
          }
        })
      })
      console.log(row.submitDataRoles)
    },
    cancel() {
      this.addDialog.account = ''
      this.btnLoading = false
      this.addDialog.accountData = []
      this.$emit('openCreateFn', false)
    },
    addNewMember() {
      // 添加新成员
      this.btnLoading = true
      const accountData = this.addDialog.accountData
      const params = []
      for (let i = 0; i < this.addDialog.accountData.length; i++) {
        if (!accountData[i].submitName) {
          this.$message.error('成员显示名不能为空')
          return false
        }
        params.push({
          userName: accountData[i].userName,
          name: accountData[i].submitName,
          password: accountData[i].password,
          roles: accountData[i].submitRoles,
          dataRoles: accountData[i].submitDataRoles
        })
      }
      addUserApi(params).then((data) => {
        this.btnLoading = false
        if (data) {
          this.cancel()
          this.$parent.getData()
          this.$parent.getAllChannelManager()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-dialog__body) {
  padding: 10px 20px;
}
.addCount {
  margin-bottom: 10px;
  overflow: hidden;
  .add-title {
    margin-bottom: 10px;
  }
  .add-input {
    display: flex;
    .add-btn {
      margin-left: 10px;
    }
  }
}
.account-list {
  overflow: hidden;
  .el-table {
    margin-top: 0;
  }
}
:deep(.addInput) {
  width: 300px;
  margin-right: 10px;
}
:deep(.el-tabs__header) {
  padding: 0 10px;
  .el-tabs__active-bar {
    width: 56px !important;
  }
}
</style>
